import { authFetch } from './fetch';

export const createCompany = (payload: any) => {
    return authFetch('/companies/signup/v2/company', {
        body: JSON.stringify(payload),
        method: 'POST',
    });
};

export const acceptTerms = (payload: any) => {
    return authFetch('/companies/signup/v2/terms', {
        method: 'POST',
        body: JSON.stringify(payload),
    });
};
